export default {
  state: {
    list: [],
    loading: false,
    search: '',
    since: '',
    until: '',
    selected: null,
    refresh: false,
    breakIds: [],
    blackList: [],
    selectedServices: []
  },
  mutations: {
    setRunsDetails (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    removeRunInTable (state, id) {
      let index = state.list.findIndex(x => x.id === id)
      if (index > -1) {
        state.list.splice(index, 1)
      }
    },
    addBlackList (state, value) {
      state.blackList.push(value)
    },
    removeBlackList (state, val) {
      let index = state.blackList.indexOf(val)
      if (val > -1) {
        state.blackList.splice(index, 1)
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/runs/table.js